var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-layout"},[_c('div',{staticClass:"row title-bar"},[_c('div',{staticClass:"col"},[_vm._t("title")],2)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._t("body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }